export class Logger {

    static log(msg): void {

        if (window.location.href.includes('dev=1')) {
            // eslint-disable-next-line no-console
            console.log(msg);
        }
    }
}
